<script>
  import Button from '$lib/components/Button.svelte';
  import Modal from '$lib/components/Modal.svelte';
  import Input from '$lib/components/form/Input.svelte';
  import { closeModal, showToast } from '$lib/features/app/modals';
  import { logger } from '$lib/logger';
  import { useQueryClient } from '@tanstack/svelte-query';
  import { useDeleteNoteMutation } from '../../service';

  let { note } = $props();

  let reason = $state('');
  const queryClient = useQueryClient();
  const deleteNoteMutation = useDeleteNoteMutation();

  function handleSubmit() {
    if (!reason) {
      return alert(
        'Du måste ange en anledning till varför journalanteckningen ska strykas',
      );
    }

    $deleteNoteMutation.mutate(
      {
        noteId: note.id,
        reason,
      },
      {
        onSuccess: () => {
          showToast('Journalen är struken', 'success');
          queryClient.invalidateQueries({ queryKey: ['notes'] });
          closeModal();
        },
        onError: (e) => {
          showToast(e.message, 'error');
          logger.error('Failed to delete note', {
            err: e instanceof Error ? e : undefined,
          });
        },
      },
    );
  }
</script>

<Modal title="Stryk journalanteckning?" size="sm">
  <form
    onsubmit={(event) => {
      event.preventDefault();
      handleSubmit();
    }}
    class="w-full"
  >
    <div class="text-gray-3">
      Varför ska journalanteckningen strykas? <Input
        autofocus={true}
        bind:value={reason}
      />
    </div>
    <div class="mt-4 flex justify-between">
      <Button onclick={closeModal} variant="secondary" iconLeft="cancel">
        Avbryt
      </Button>
      <Button
        type="submit"
        variant="primary"
        class="w-40"
        loading={$deleteNoteMutation.isPending}
      >
        Stryk
      </Button>
    </div>
  </form>
</Modal>
